import { Contract } from "./Contract";
import { Pair } from "../obj/Pair";

export class ExistingContract extends Contract {
    contractDocument: Pair = null!;

    getSalesPrice(): number {
       return this.price;
    }

}
